import { render, staticRenderFns } from "./ruleBox.vue?vue&type=template&id=7fef7904&scoped=true&"
import script from "./ruleBox.vue?vue&type=script&lang=js&"
export * from "./ruleBox.vue?vue&type=script&lang=js&"
import style0 from "./ruleBox.vue?vue&type=style&index=0&id=7fef7904&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fef7904",
  null
  
)

export default component.exports